function selectStyler() {

    var select = $('.select select');

    if ( select.length ) {
        select.styler({
            selectSmartPositioning: false
        });
    }

}
